<template>
  <div id="about">
    <v-container>
      <v-row class="mb-13 pb-13">
        <v-col
          cols="12"
          lg="4"
          :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-left'"
        >
          <h1 class="primary300--text mb-2">
            About Us
          </h1>
          <p>
            The Advanced Technology Research Council (ATRC) of Abu Dhabi has introduced the
            ResearchHUB Catalogue, showcasing local research capabilities and resources. This
            innovative platform provides access to research facilities, services and patents in
            participating entities, thereby increasing the scope for research and innovation and
            maximizing the use of existing research resources.The ResearchHUB Portal undergoes
            regular updates to expand its service offerings and improve features.
          </p>
          <v-btn
            color="primary200"
            dark
            class="mt-16  pl-16 pr-16 pt-9 pb-9 white--text "
            x-large
            @click="redirectToCatalogue"
          >
            Go to Catalogue
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          lg="6"
          class="text-right "
          :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-right'"
        >
          <div class="image-wrapper">
            <img
              :src="require('@/assets/img/landing-page/pages/new_about.jpg')"
              alt="About Us Image"
            />
            <div class="overlay"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    //this.$vuetify.goTo(1, {});
  },
  methods: {
    redirectToCatalogue() {
      const roles = this.$store.getters.roles;
      const marketplaceServicesViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Services';
      if (roles != null) {
        let routePath = '';
        routePath = '/marketplace/services';
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll },
        });
      } else {
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll },
        });
      }
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  display: inline-block;
}

.image-wrapper img {
  display: block;
  width: 700px;
  height: auto;
  border-radius: 24px;
}

#about .v-btn {
  font-weight: bold;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .image-wrapper img {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 425px) {
  #about .v-btn {
    font-size: 14px;
    max-width: 250px;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(100, 0, 255, 0.2);
  z-index: 0;
  pointer-events: none;
  border-radius: 24px;
}
</style>
